const timeAgo = (dateString) => {
    const now = new Date();
    const pastDate = new Date(dateString);
    const secondsAgo = Math.floor((now - pastDate) / 1000);
    const minutesAgo = Math.floor(secondsAgo / 60);
    const hoursAgo = Math.floor(minutesAgo / 60);
    const daysAgo = Math.floor(hoursAgo / 24);

    if (daysAgo > 0) return `${daysAgo}d ago`;
    if (hoursAgo > 0) return `${hoursAgo}hr${hoursAgo > 1 ? 's' : ''} ago`;
    if (minutesAgo > 0) return `${minutesAgo}min${minutesAgo > 1 ? 's' : ''} ago`;
    return `${secondsAgo}s`;
}
export default timeAgo;